// Live's Generate Script of a template's form (`ScriptGenerationOverlayWithProduct`, spec
// G14-templates PR 13): the shared overlay with live's product picker at its footer. Where the
// form has no product of its own (Your Personal Clone, Talking Head Overlay) the product only
// seeds the script's start, so it lives and dies with the overlay, as live's; where it has one
// (Promote Your Product), the picker is the form's product.
import { Archive } from "lucide-react";
import { useState } from "react";

import { ProductListPopover, type ListedProduct } from "../../../platform/media/ProductListPopover";
import { ScriptOverlay } from "../../../platform/scripts/ScriptOverlay";
import { SourceTool } from "../../../ui/SourceTool";

export interface ScriptOverlayWithProductProps {
  teamId: string;
  brandId: string;
  /** Live's brief placeholder for the form. */
  placeholder: string;
  pending: boolean;
  error: unknown;
  /** The brief, and the product picked for it, or none. */
  onGenerate: (brief: string, productId: string | null) => void;
  onCancel: () => void;
  /** The form's own product and its change, where it has one; else the overlay keeps its own. */
  product?: { value: ListedProduct | null; onChange: (product: ListedProduct | null) => void };
}

/** Live's overlay: the brief, and at the footer "Products" (one, live's popover). */
export function ScriptOverlayWithProduct(props: ScriptOverlayWithProductProps) {
  const { teamId, brandId, placeholder, pending, error, onGenerate, onCancel } = props;
  const [own, setOwn] = useState<ListedProduct | null>(null);
  const product = props.product === undefined ? own : props.product.value;
  const setProduct = props.product === undefined ? setOwn : props.product.onChange;
  const [opened, setOpened] = useState(false);
  return (
    <ScriptOverlay
      placeholder={placeholder}
      pending={pending}
      error={error}
      onCancel={onCancel}
      onGenerate={(brief) => onGenerate(brief, product?.productId ?? null)}
      footerLeft={
        <ProductListPopover
          teamId={teamId}
          brandId={brandId}
          chosenId={product?.productId ?? null}
          opened={opened}
          onClose={() => setOpened(false)}
          onPick={setProduct}
          position="top-start"
          anchor={(wrap) => (
            <SourceTool
              label="Products"
              icon={<Archive size={20} strokeWidth={1.5} />}
              view={product}
              removeLabel="Remove the product"
              onRemove={() => setProduct(null)}
              onClick={() => setOpened((open) => !open)}
              open={opened}
              disabled={pending}
              target={wrap}
            />
          )}
        />
      }
    />
  );
}
